module.exports = __webpack_public_path__ + "img/down_zbgj1.cd2e8f08.png";